import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MenuIcon, ChevronDown, Globe, SearchIcon, BookmarkIcon, BellIcon, UserCircle, LayoutDashboardIcon } from 'lucide-react';
interface HeaderProps {
  onMenuToggle: () => void;
  savedCount: number;
  onSavedClick: () => void;
  onSearch: (query: string) => void;
  onDashboardClick: () => void;
}
export function Header({
  onMenuToggle,
  savedCount,
  onSavedClick,
  onSearch,
  onDashboardClick
}: HeaderProps) {
  const [searchValue, setSearchValue] = useState('');
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchValue);
    setIsSearchOpen(false);
  };
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-209">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl" data-id="element-210">
        <div className="flex items-center justify-between h-16" data-id="element-211">
          <div className="flex items-center" data-id="element-212">
            <button className="md:hidden mr-2 hover:bg-gray-100 p-1 rounded-full transition" onClick={onMenuToggle} data-id="element-213">
              <MenuIcon size={24} className="text-black" data-id="element-214" />
            </button>
            <Link to="/" className="font-bold text-2xl cursor-pointer" data-id="element-215">
              <span data-id="element-216">KODI</span>
              <span className="text-yellow-400" data-id="element-217">F</span>
            </Link>
          </div>
          <div className="hidden md:flex items-center space-x-6 ml-6" data-id="element-218">
            <Link to="/" className="text-sm font-medium hover:text-green-600 transition" data-id="element-219">
              Home
            </Link>
            <Link to="/about" className="text-sm font-medium hover:text-green-600 transition" data-id="element-220">
              About Us
            </Link>
          </div>
          <motion.div className={`${isSearchOpen ? 'flex' : 'hidden md:flex'} items-center space-x-4 flex-1 max-w-xl mx-8 absolute md:relative left-0 right-0 top-0 md:top-auto px-4 md:px-0 h-16 md:h-auto bg-white z-50`} initial={false} animate={{
          y: isSearchOpen ? 0 : -10,
          opacity: isSearchOpen ? 1 : window.innerWidth >= 768 ? 1 : 0
        }} data-id="element-221">
            <form className="relative flex-1" onSubmit={handleSearch} data-id="element-222">
              <input type="text" placeholder="Search for coupons..." className="w-full py-2 px-4 pr-10 rounded-full bg-gray-100 focus:outline-none focus:ring-2 focus:ring-green-500" value={searchValue} onChange={e => setSearchValue(e.target.value)} data-id="element-223" />
              <button type="submit" className="absolute right-3 top-2.5 text-gray-400 hover:text-gray-600 transition" data-id="element-224">
                <SearchIcon size={18} className="text-black" data-id="element-225" />
              </button>
            </form>
            {isSearchOpen && <button className="md:hidden text-gray-500" onClick={() => setIsSearchOpen(false)} data-id="element-226">
                Cancel
              </button>}
          </motion.div>
          <div className="flex items-center space-x-3" data-id="element-227">
            <button className="md:hidden p-2 rounded-full hover:bg-gray-100" onClick={() => setIsSearchOpen(true)} data-id="element-228">
              <SearchIcon size={20} className="text-black" data-id="element-229" />
            </button>
            <button className="p-2 rounded-full hover:bg-gray-100 relative" onClick={onDashboardClick} data-id="element-230">
              <LayoutDashboardIcon size={20} className="text-black" data-id="element-231" />
            </button>
            <button className="flex items-center text-sm font-medium relative hover:text-green-600 transition p-2 rounded-full hover:bg-gray-100" onClick={onSavedClick} data-id="element-232">
              <BookmarkIcon size={20} className="text-black" data-id="element-233" />
              {savedCount > 0 && <span className="absolute -top-1 -right-1 bg-green-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center" data-id="element-234">
                  {savedCount}
                </span>}
            </button>
          </div>
        </div>
      </div>
    </header>;
}